(function () {
  var closeTimers = new WeakMap();

  function clearCloseTimer(drawer) {
    var timer = closeTimers.get(drawer);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(drawer);
    }
  }

  function setDrawerOpen(root, drawer, openBtn, open) {
    if (!drawer) return;

    clearCloseTimer(drawer);

    if (open) {
      drawer.hidden = false;
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.setAttribute('scroll-lock', '');

      /* Forzar frame cerrado → luego abrir, para que corra el slide */
      drawer.classList.remove('is-open');
      void drawer.offsetWidth;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
      });
      return;
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('scroll-lock');

    var panel = drawer.querySelector('.oleum-header__drawer-panel');

    function finishClose() {
      clearCloseTimer(drawer);
      if (drawer.classList.contains('is-open')) return;
      drawer.hidden = true;
      drawer.setAttribute('hidden', '');
    }

    if (panel) {
      var onEnd = function (event) {
        if (event.target !== panel) return;
        if (event.propertyName && event.propertyName !== 'transform') return;
        panel.removeEventListener('transitionend', onEnd);
        finishClose();
      };
      panel.addEventListener('transitionend', onEnd);
      closeTimers.set(
        drawer,
        setTimeout(function () {
          panel.removeEventListener('transitionend', onEnd);
          finishClose();
        }, 320)
      );
    } else {
      finishClose();
    }
  }

  function initHeader(root) {
    if (!root || root.dataset.oleumHeaderReady === 'true') return;
    root.dataset.oleumHeaderReady = 'true';

    var drawer = root.querySelector('[data-oleum-drawer]');
    var openBtn = root.querySelector('[data-oleum-menu-open]');

    // Escritorio: al pasar a otro menú de nivel superior, cerrar el que quedó abierto por foco
    root.querySelectorAll('.oleum-header-nav:not(.oleum-header-nav--drawer) .oleum-header-nav__item').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var active = document.activeElement;
        if (
          active &&
          active.blur &&
          !item.contains(active) &&
          active.closest &&
          active.closest('.oleum-header-nav__dropdown')
        ) {
          active.blur();
        }
      });
    });

    // Escritorio (≥1200px): mantener dropdown abierto mientras el cursor está en el ítem o el panel
    var desktopNav = root.querySelector('.oleum-header-nav:not(.oleum-header-nav--drawer)');
    if (desktopNav) {
      var dropdownItems = desktopNav.querySelectorAll('.oleum-header-nav__item--has-children');
      var dropdownCloseTimer = null;

      function setDropdownOpen(item, open) {
        if (!item) return;
        item.classList.toggle('is-open', open);
        var link = item.querySelector('.oleum-header-nav__link');
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      dropdownItems.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(dropdownCloseTimer);
          dropdownItems.forEach(function (sibling) {
            if (sibling !== item) setDropdownOpen(sibling, false);
          });
          setDropdownOpen(item, true);
        });

        item.addEventListener('mouseleave', function () {
          clearTimeout(dropdownCloseTimer);
          dropdownCloseTimer = setTimeout(function () {
            setDropdownOpen(item, false);
          }, 150);
        });
      });
    }

    root.querySelectorAll('[data-oleum-mobile-submenu-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        var item = toggle.closest('.oleum-header-nav__item');
        if (!item) return;
        event.preventDefault();
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    root.querySelectorAll('[data-oleum-nested-submenu-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var item = toggle.closest('.oleum-header-nav__dropdown-item');
        if (!item) return;
        var sublist = item.querySelector('.oleum-header-nav__sublist');
        var isOpen = item.classList.contains('is-open');
        if (!isOpen) {
          var list = item.closest('.oleum-header-nav__dropdown-list');
          if (list) {
            list.querySelectorAll(':scope > .oleum-header-nav__dropdown-item.is-open').forEach(function (sib) {
              if (sib === item) return;
              sib.classList.remove('is-open');
              var sibToggle = sib.querySelector('[data-oleum-nested-submenu-toggle]');
              if (sibToggle) sibToggle.setAttribute('aria-expanded', 'false');
              var sibSublist = sib.querySelector('.oleum-header-nav__sublist');
              if (sibSublist) sibSublist.hidden = true;
            });
          }
        }
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (sublist) sublist.hidden = isOpen;
      });
    });

    function syncDropdownBridge() {
      var inner = root.querySelector('.oleum-header__inner');
      var link = root.querySelector('.oleum-header-nav:not(.oleum-header-nav--drawer) .oleum-header-nav__link');
      if (!inner || !link) return;
      var bridge = Math.max(0, Math.round(inner.getBoundingClientRect().bottom - link.getBoundingClientRect().bottom));
      root.style.setProperty('--oleum-dropdown-bridge', bridge + 'px');
    }

    syncDropdownBridge();
    window.addEventListener('resize', syncDropdownBridge);
    window.addEventListener('load', syncDropdownBridge);

    /* Escape por header */
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        setDrawerOpen(root, drawer, openBtn, false);
      }
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-oleum-header]').forEach(initHeader);
  }

  /* Delegación única abrir/cerrar (capture) */
  document.addEventListener(
    'click',
    function (event) {
      var closeEl = event.target.closest('[data-oleum-menu-close]');
      if (closeEl) {
        var closeRoot = closeEl.closest('[data-oleum-header]');
        if (!closeRoot) return;
        var closeDrawer = closeRoot.querySelector('[data-oleum-drawer]');
        var closeOpenBtn = closeRoot.querySelector('[data-oleum-menu-open]');
        if (!closeDrawer || !closeDrawer.classList.contains('is-open')) return;
        event.preventDefault();
        event.stopPropagation();
        setDrawerOpen(closeRoot, closeDrawer, closeOpenBtn, false);
        return;
      }

      var openBtn = event.target.closest('[data-oleum-menu-open]');
      if (!openBtn) return;
      var root = openBtn.closest('[data-oleum-header]');
      if (!root) return;
      var drawer = root.querySelector('[data-oleum-drawer]');
      if (!drawer) return;
      event.preventDefault();
      event.stopPropagation();
      setDrawerOpen(root, drawer, openBtn, true);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
